import { AlertTriangle } from "lucide-react";

export function DisclaimerCard() {
  return (
    <section className="container py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <p className="eyebrow">§ 00 · Notice</p>
          <h2 className="mt-3 font-display text-3xl font-medium tracking-tight text-foreground">
            Read this before you begin.
          </h2>
          <div className="mt-4 rule-tick" />
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
            The disclaimer below applies to every output produced by this tool, including
            the categorisation, evidence gap list, operational risk summary and the
            30 / 60 / 90 day action plan.
          </p>
        </div>
        <div className="lg:col-span-8">
          <div className="paper-card flex flex-col gap-4 p-6 sm:p-8">
            <div className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-sm bg-warning-soft text-warning">
                <AlertTriangle className="h-4 w-4" />
              </span>
              <div className="space-y-1">
                <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-warning">
                  Statutory disclaimer
                </p>
                <h3 className="font-display text-lg font-medium text-foreground">
                  Readiness guidance only.
                </h3>
              </div>
            </div>
            <p className="text-[15px] leading-relaxed text-foreground">
              NDIS 0138 Readiness is a consultancy readiness tool only. It is not legal advice,
              an Approved Quality Auditor report, an official NDIS Commission tool, a
              registration guarantee, or a compliance certification.
            </p>
            <div className="grid grid-cols-1 gap-3 border-t border-border pt-4 sm:grid-cols-2">
              {[
                "Not legal advice",
                "Not an Approved Quality Auditor report",
                "Not an official NDIS Commission tool",
                "Not a registration guarantee",
                "Not a compliance certification",
                "No client or participant data stored"
              ].map((item) => (
                <div
                  key={item}
                  className="flex items-center gap-2 text-sm text-muted-foreground"
                >
                  <span className="h-1 w-1 rounded-full bg-accent" />
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
